import { render } from "./InternetToolBar.vue?vue&type=template&id=4726d9cc&scoped=true"
import script from "./InternetToolBar.vue?vue&type=script&lang=js"
export * from "./InternetToolBar.vue?vue&type=script&lang=js"

import "./InternetToolBar.vue?vue&type=style&index=0&id=4726d9cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4726d9cc"]])

export default __exports__